/*** 
 * 描述：浏览器不兼容
 */ 
import { Component } from '@angular/core';
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';

@Component({
  selector: 'sw-compatibility',
  templateUrl: './compatibility.html',
})

export class SwCompatibilityComponent {
  /**
   * 默认主页地址
   */
  defaultPortal: string = ''
  constructor(
    private router: Router, //路由服务
  ) { 
    this.defaultPortal = environment.defaultPortal;
  }

  isMac:boolean = false

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.OSnow()
  }

  //判断系统类型
  OSnow(){
    var agent = navigator.userAgent.toLowerCase();
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        //your code
        this.isMac = false
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        //your code
        this.isMac = false
    }
    if(isMac){
        //your code
        this.isMac = true
    }
  }
}